import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, { Tab } from "material-ui/Tabs";
import Switch from "material-ui/Switch";
import Divider from "material-ui/Divider";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormGroup
} from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import withRole from "../../hoc/role";

import { DraggableModalFrame, ModalHeader, ModalContents, ModalFooter } from "../../common/modal";
import { isSmartFlagSupportedDevice, isVDVType } from "../../../common/utils";

import {
  CUSTOM_METADATA_STANDARD,
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER
} from "../../../common/constants";

const MenuItemAddCustomer = withRole(
  props => {
    return <MenuItem {...props} />;
  },
  [...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER]
);

class NewJob extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      errors: {},
      tabs: [],
      tabPosition: 0,
      defaultTabs: [props.translate("job_details"), props.translate("job_metadata")],
      mobileTabs: [props.translate("job_details")],
      job: {
        publish: false,
        status: false,
        enablesync: true,
        enableJobComplete: false,
        name: "",
        deviceid: props.prevSelectedDeviceid ? props.prevSelectedDeviceid : "",
        customerid: "",
        metadatalookupid: null,
        metadataStandardCustom: {
          6: { enabled: false, value: "" },
          5: { enabled: false, value: "" },
          4: { enabled: false, value: "" },
          3: { enabled: false, value: "" },
          2: { enabled: false, value: "" },
          1: { enabled: false, value: "" }
        }
      },
      customer: {
        name: "",
        address: "",
        contactemail: "",
        telephoneno: "",
        contact: "",
        city: "",
        state: "",
        country: "",
        zipcode: ""
      },
      mode: "create",
      showDeviceTypes: true,
      disableJobIdentifiers: false,
      jobModalError: null,
      modalRef: React.createRef()
    };
  }

  setEditJobState() {
    const { editJobData } = this.props;
    if (editJobData) {
      let job = { ...this.state.job, ...editJobData };

      Object.keys(job.metadataStandardCustom).map((key, idx) => {
        job.metadataStandardCustom[key] = {
          enabled: job[`level${key}`] ? true : false,
          value: job[`level${key}`] ? job[`level${key}`] : ""
        };
        return null;
      });
      job.enableJobComplete = true;

      this.setState({
        job: job,
        mode: "edit",
        open: true,
        tabs: isVDVType(job.deviceid) ? this.state.mobileTabs : this.state.defaultTabs,
        showDeviceTypes: editJobData.deviceid === null ? false : true,
        disableJobIdentifiers: editJobData.deviceid === null ? true : false
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customerId) {
      this.setState({
        job: {
          ...this.state.job,
          customerid: parseInt(nextProps.customerId, 10)
        }
      });
    }

    if (nextProps.form && nextProps.form != this.props.form) {
      this.setState({
        open: false,
        tabPosition: 0
      });
    }

    // this.setEditJobState()
  }

  componentWillMount() {
    if (this.props.editJobData) {
      this.setEditJobState();
    } else {
      this.setState({
        tabs: isVDVType(this.state.job.deviceid)
          ? this.state.mobileTabs
          : this.state.defaultTabs
      });
    }
  }

  handleTabChange = (event, value) => {
    let validate = this.validate();
    let { tabPosition } = this.state;
    if (validate || tabPosition - 1 >= 0) this.setState({ tabPosition: value });
  };

  tabNext() {
    let check = this.canTabNext();
    let validate = this.validate();
    if (validate && check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    let check = this.canTabBack();
    let validate = this.validate();
    if (check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;
    return pos < tabs.length ? { can: true, pos: pos } : false;
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : false;
  }

  tabsComplete() {
    const { tabs, tabPosition } = this.state;
    return tabPosition === tabs.length - 1 ? true : false;
  }

  handleClose = () => {
    this.setState({
      open: false
    });
    this.props.cancel();
  };

  onChange = e => {
    let job = { ...this.state.job };
    job[e.target.name] = e.target.value;
    if (e.target.name === "deviceid" && !isSmartFlagSupportedDevice(job.deviceid)) {
      job.smartFlagProfileId = "";
    }
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    this.setState({ job, errors });

    if (e.target.name === "deviceid") {
      let tabs = { ...this.state.tabs };
      if (isVDVType(job.deviceid)) {
        tabs = this.state.mobileTabs;
      }
      else {
        tabs = this.state.defaultTabs;
      }
      this.setState({ tabs });
    }
  }

  onChangeCustomerInfo = e => {
    let customer = { ...this.state.customer };
    customer[e.target.name] = e.target.value;
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    this.setState({ customer, errors });
  };

  onChangeCustomer = e => {
    if (e.target.value === "add-customer") {
      this.props.addCustomer();
    } else {
      let job = { ...this.state.job };
      job[e.target.name] = e.target.value;
      let errors = { ...this.state.errors };
      errors = {
        ...errors,
        [e.target.name]: false
      };
      this.setState({
        job: job,
        errors
      });
    }
  };

  onToggleChange = (e, checked) => {
    let job = { ...this.state.job };
    job[e.target.name] = checked;
    this.setState({ job: job });
  };

  onCustomCheckChange = e => {
    let job = { ...this.state.job };
    let enabled = !job.metadataStandardCustom[e.target.name].enabled;
    job.metadataStandardCustom[e.target.name] = {
      enabled: enabled,
      value: enabled
        ? document.querySelector(`select[name="${e.target.name}"]`).value
        : ""
    };
    this.setState({ job: job });
  };

  onCustomChange = e => {
    let job = { ...this.state.job };
    job.metadataStandardCustom[e.target.name] = {
      enabled: true,
      value: e.target.value
    };
    this.setState({ job: job });
  };

  onJobCompleteChange = e => {
    let job = { ...this.state.job };
    job.status = !job.status;
    this.setState({ job: job });
  };

  validate = () => {
    const { job, tabPosition, customer } = this.state;
    const { translate } = this.props;
    let errors = {};
    switch (tabPosition) {
      case 0:
        if (job.name.trim() === "") {
          errors.name = translate("formfield_error_general_required");
        }
        if (/[&^\\\\@#*/|<>=%^,�\n\t]/.test(job.name.trim())) {
          errors.name = translate("formfield_error_general_type_alphanumeric");
        }
        if (job.deviceid === "") {
          errors.deviceid = true;
        }
        if (job.customerid === "add-customer") {
          errors.customername = customer.name === "";
          errors.address = customer.address === "";
          errors.contactemail = customer.contactemail === "";
          errors.telephoneno = customer.telephoneno === "";
          errors.contact = customer.contact === "";
          errors.customercity = customer.city === "";
          errors.customerstate = customer.state === "";
          errors.customercountry = customer.country === "";
          errors.customerzipcode = customer.zipcode === "";
        } else if (job.customerid === "") {
          errors.customerid = true;
        }

        break;
      case 1:
        if (job.metadatalookupid === "") {
          errors.metadatalookupid = true;
        }
        break;
      case 2:
        break;
      default:
        return true;
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
      return false;
    } else {
      return true;
    }
  };

  saveNewJob = (job, customer) => {
    const { saveNewJob } = this.props;
    // this.modalState = job
    this.props
      .saveNewJob(job, customer)
      .then(resp => {
        this.setState({
          jobModalError: null
        });
      })
      .catch(err => {
        this.setState({
          jobModalError: err
        });
      });
  };

  saveEditJob = (job, customer) => {
    this.props
      .saveEditJob(job, customer)
      .then(resp => {
        this.setState({
          jobModalError: null
        });
      })
      .catch(err => {
        this.setState({
          jobModalError: err
        });
      });
  };

  saveJob() {
    let { job, customer, mode } = this.state;
    if (!this.validate()) {
      return;
    }

    const supportsSmartFlags = isSmartFlagSupportedDevice(job.deviceid);
    const smartFlagProfileId = supportsSmartFlags
      ? (job.smartFlagProfileId || null)
      : null;
    const smartFlagProfileDisabled = supportsSmartFlags
      ? mode === "create"
        ? !smartFlagProfileId
        : !!job.smartFlagProfileDisabled
      : false;

    let payload = {
      name: job.name,
      customerid: job.customerid,
      deviceid: job.deviceid,
      status: job.status,
      publish: false,
      enablesync: job.enablesync,
      smartFlagProfileId,
      smartFlagProfileDisabled,
      metadatalookupid:
        job.metadatalookupid === "~" ? null : job.metadatalookupid,
      level1:
        job.metadatalookupid != CUSTOM_METADATA_STANDARD
          ? null
          : job.metadataStandardCustom[1].value,
      level2:
        job.metadatalookupid != CUSTOM_METADATA_STANDARD
          ? null
          : job.metadataStandardCustom[2].value,
      level3:
        job.metadatalookupid != CUSTOM_METADATA_STANDARD
          ? null
          : job.metadataStandardCustom[3].value,
      level4:
        job.metadatalookupid != CUSTOM_METADATA_STANDARD
          ? null
          : job.metadataStandardCustom[4].value,
      level5:
        job.metadatalookupid != CUSTOM_METADATA_STANDARD
          ? null
          : job.metadataStandardCustom[5].value,
      level6:
        job.metadatalookupid != CUSTOM_METADATA_STANDARD
          ? null
          : job.metadataStandardCustom[6].value
    };

    if (mode === "create") {
      this.saveNewJob(payload, this.props.selectedCustomerId);
    } else {
      this.saveEditJob(
        { ...this.props.editJobData, ...payload },
        this.props.selectedCustomerId
      );
    }
    this.props.setPrevSelectedDeviceid(job.deviceid);
  }

  render() {
    const {
      classes,
      translate,
      customers,
      devices,
      standards,
      selectedCustomerId,
      smartFlagProfiles
    } = this.props;

    let { custom } = this.props;

    const {
      job,
      errors,
      tabs,
      tabPosition,
      mode,
      showDeviceTypes,
      disableJobIdentifiers,
      jobModalError,
      defaultTabs,
      mobileTabs,
      modalRef
    } = this.state;

    const deviceOptions = devices || [];
    const standardOptions = standards || [];
    custom = custom || [];

    if (job.metadatalookupid === null) {
      job.metadatalookupid = "~";
    }

    const customerOptions = customers && customers.data ? customers.data : [];
    const filteredCustomerOptions = selectedCustomerId
      ? customerOptions.filter(customer => customer.id == selectedCustomerId)
      : customerOptions;
    const visibleCustomerOptions = filteredCustomerOptions.length
      ? filteredCustomerOptions
      : customerOptions;

    custom = custom.sort((a, b) => b.level < a.level);
    return (
      <Modal open={this.state.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <DraggableModalFrame
            paperClassName={classes.modal}
            header={
              <ModalHeader>
                <Typography
                  type="headline"
                  color="inherit"
                  className={classes.modalHeader}
                >
                  {mode === "create"
                    ? translate("job_add")
                    : translate("job_edit")}
                </Typography>
                <Button className={classes.close} onClick={this.handleClose}>
                  <Icon>clear</Icon>
                </Button>
              </ModalHeader>
            }
          >
            <ModalContents>
              {jobModalError && jobModalError === "error_duplicatejob" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("job_duplicate_error")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("job_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={tab} />;
                  })}
                </Tabs>

                {tabPosition === 0 && (
                  <div className={classes.summary}>
                    <TextField
                      error={errors.name ? true : false}
                      required
                      name="name"
                      label={translate("job_name")}
                      margin="normal"
                      fullWidth
                      value={job.name}
                      onChange={this.onChange}
                      helperText={
                        errors.name ? errors.name : translate("job_name_help")
                      }
                      className={classes.textField}
                    />

                    {showDeviceTypes && (
                      <FormControl
                        disabled={mode !== "create"}
                        className={classes.textField}
                        margin="normal"
                        error={errors.deviceid}
                      >
                        <InputLabel htmlFor="device" required>
                          {translate("job_device")}
                        </InputLabel>
                        <Select
                          value={job.deviceid}
                          onChange={this.onChange}
                          input={
                            <Input
                              name="deviceid"
                              id="deviceid"
                              value={job.deviceid}
                              defaultValue={job.deviceid}
                            />
                          }
                          fullWidth
                        >
                          {deviceOptions
                            ? deviceOptions
                                .filter(
                                  device =>
                                    device.id != "10_g" &&
                                    device.id != "lantekiii"
                                )
                                .map((device, index) => {
                                  return (
                                    <MenuItem key={index} value={device.id}>
                                      {translate(device.id)}
                                    </MenuItem>
                                  );
                                })
                            : null}
                        </Select>
                        <FormHelperText>
                          {translate("job_device_help")}
                        </FormHelperText>
                      </FormControl>
                    )}

                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      error={errors.customerid}
                    >
                      <InputLabel htmlFor="customer" required>
                        {translate("job_customer")}
                      </InputLabel>
                      {selectedCustomerId ? (
                        <Select
                          value={job.customerid}
                          onChange={this.onChangeCustomer}
                          input={
                            <Input
                              name="customerid"
                              id="customerid"
                              value={job.customerid}
                              defaultValue={job.customerid}
                            />
                          }
                          fullWidth
                        >
                          {visibleCustomerOptions.map((customer, index) => {
                            return (
                              <MenuItem key={index} value={customer.id}>
                                {customer.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      ) : (
                        <Select
                          value={job.customerid}
                          onChange={this.onChangeCustomer}
                          input={
                            <Input
                              name="customerid"
                              id="customerid"
                              value={job.customerid}
                              defaultValue={job.customerid}
                            />
                          }
                          fullWidth
                        >
                          <MenuItemAddCustomer
                            key={"add-customer"}
                            value={"add-customer"}
                          >
                            {translate("job_add_customer")}
                          </MenuItemAddCustomer>
                          <Divider />
                          {customerOptions.map((customer, index) => {
                            return (
                              <MenuItem key={index} value={customer.id}>
                                {customer.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                      <FormHelperText>
                        {translate("job_customer_help")}
                      </FormHelperText>
                    </FormControl>

                    {mode !== "edit" &&
                    this.props.activeFeatures?.some(f => f.featureName === 'smart_flag') &&
                    isSmartFlagSupportedDevice(job.deviceid) &&
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                    >
                      <InputLabel htmlFor="smartFlagProfileId">
                        {translate("job_smart_flag_profile")}
                      </InputLabel>
                      <Select
                        value={job.smartFlagProfileId || ""}
                        onChange={this.onChange}
                        input={
                          <Input
                            name="smartFlagProfileId"
                            id="smartFlagProfileId"
                            value={job.smartFlagProfileId}
                          />
                        }
                        fullWidth
                      >
                        <MenuItem value={""}>
                          {translate("none_constant")}
                        </MenuItem>
                        {smartFlagProfiles && smartFlagProfiles.map((profile) => (
                          <MenuItem key={profile.id} value={profile.id}>
                            {profile.name}{profile.isDefault ? ` (${translate("customer_smart_flag_default")})` : ""}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>
                        {translate("job_smart_flag_profile_help")}
                      </FormHelperText>
                    </FormControl>}
                  </div>
                )}

                {tabPosition === 1 && (
                  <div className={classes.summary}>
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.metadatalookupid}
                    >
                      <InputLabel htmlFor="metadatalookupid">
                        {translate("job_metadata")}
                      </InputLabel>
                      <Select
                        value={job.metadatalookupid}
                        onChange={this.onChange}
                        input={
                          <Input
                            name="metadatalookupid"
                            id="metadatalookupid"
                            value={job.metadatalookupid}
                          />
                        }
                        fullWidth
                        disabled={disableJobIdentifiers}
                      >
                          {standardOptions
                          ? standardOptions.map((standard, index) => {
                              return (
                                <MenuItem key={index} value={standard.id}>
                                  {standard.name}
                                </MenuItem>
                              );
                            })
                          : null}
                        <Divider />
                        <MenuItem key={"not-required"} value={"~"}>
                          {translate("job_metadata_not_required")}
                        </MenuItem>
                      </Select>
                      <FormHelperText>
                        {translate("job_metadata_help")}
                      </FormHelperText>
                    </FormControl>

                    {job.metadatalookupid === CUSTOM_METADATA_STANDARD &&
                      custom &&
                      custom
                        .sort((a, b) => {
                          return a.level > b.level
                            ? -1
                            : a.level < b.level
                            ? 1
                            : 0;
                        })
                        .map((c, index) => {
                          return c.level !== 1 ? (
                            <div key={index}>
                              <Checkbox
                                name={c.level}
                                checked={
                                  job.metadataStandardCustom[c.level].enabled
                                }
                                onChange={this.onCustomCheckChange}
                                // type="checkbox"
                              />
                              <select
                                name={c.level}
                                value={
                                  job.metadataStandardCustom[c.level].value
                                }
                                onChange={this.onCustomChange}
                                disabled={
                                  !job.metadataStandardCustom[c.level].enabled
                                }
                              >
                                {c.values.map((o, index) => {
                                  return (
                                    <option key={index} value={o.id}>
                                      {o.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          ) : null;
                        })}
                  </div>
                )}
              </form>
            </ModalContents>

            <ModalFooter classes={classes}>
              <Button
                raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={!this.canTabBack().can ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button
                raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={!this.canTabNext().can ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {this.tabsComplete() ? (
                <Button
                  raised
                  className={classes.submit}
                  onClick={() => this.saveJob()}
                  type="submit"
                >
                  {translate("general_submit")}
                </Button>
              ) : null}
            </ModalFooter>
          </DraggableModalFrame>
        </div>
      </Modal>
    );
  }
}

export default withStyles(styles)(NewJob);
